<template>
  <div class="">

    <div class="btn btn-success my-2 rounded-pill" v-b-modal="`create-extra-option`">ساخت ایتم +</div>

    <b-modal :id="`create-extra-option`" size="lg" hide-footer>
      <div class="text-right">
        <extra-option-form @refresh="refreshComponent" :extraOptions="extraOptions"/>

        <hr>
        <div class="btn btn-danger" @click="$bvModal.hide('create-extra-option')">انصراف</div>

      </div>
    </b-modal>

    <div class="extra-items-list">
      <table class="table">
        <thead>
        <tr>
          <th scope="col">نام</th>
          <th scope="col">وضعیت انتخاب</th>
          <th scope="col">نوع</th>
          <th scope="col">#</th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="extraOption in extraOptions" v-if="extraOption.properties.status">
          <th>{{ extraOption.properties.title }}</th>
          <td>{{ extraOption.properties.select_status }}</td>
          <td>{{ extraOption.properties.type }}</td>
          <td>
            <b-badge class="mx-1 cursor_pointer bg-danger rounded-pill" @click="destroyExtraOption(extraOption)">حذف
            </b-badge>
            <b-badge v-b-modal="`update-extra-option-${extraOption.id}`" class="mx-1 cursor_pointer rounded-pill">
              ویرایش
            </b-badge>


            <b-modal :id="`update-extra-option-${extraOption.id}`" hide-footer>
              <div class="text-right">
                <extra-option-form @refresh="refreshComponent" :extraOptions="extraOptions"
                                   :extra-option-item="extraOption"/>
              </div>
            </b-modal>

          </td>
        </tr>
        </tbody>
      </table>
    </div>

  </div>
</template>

<script>
import ExtraOptionForm from "./ExtraOptionForm.vue";

export default {
  name: "ExtraOption",
  components: {ExtraOptionForm},
  props: {
    reservation: {},
  },
  computed: {
    extraOptions() {
      return this.reservation.reservationRule.extra_items
    },
  },
  methods: {
    destroyExtraOption(extraItem) {
      if (confirm('آیا از حذف ایتم اطمینان دارید؟')) {
        extraItem.properties.status = false
      }
      this.$forceUpdate()
    },
    refreshComponent() {
      this.$forceUpdate()
    }
  }
}
</script>


<style scoped>
.cursor_pointer {
  cursor: pointer;
}
</style>